<template>
  <section :class="$style.root">
    <div :class="$style.content">
      <h2 :class="$style.heading">
        {{ title }}
      </h2>
      <ul
        v-if="data?.items"
        :class="$style.list"
      >
        <li
          v-for="item in data?.items"
          :key="item.id"
        >
          <PagesExhibitionsSlugCreditsItemComponent :data="item" />
        </li>
      </ul>
    </div>
  </section>
</template>

<script setup>
const props = defineProps({
  data: Object
})

const localizedData = computed(() => {
  return i18nGetLocalizedData(baseStrapiGetAttributes(props?.pageData?.data))
})

const title = computed(() => i18nGetLocalizedString(props?.data))

</script>

<style module lang=scss>
.root {
  background-color: var(--color--gray);
}

.content {
  composes: container--default from global;
  padding: var(--unit--vertical) var(--unit--horizontal);
}

.heading {
  composes: reset-heading font-size-default from global;
  text-align: center;
  text-transform: uppercase;
  margin-bottom: calc(var(--unit--vertical) * 2);
}

.list {
  composes: reset-list font-size-small from global;

  columns: 2;
  gap: var(--unit--vertical);

  @media (max-width: $breakpoint-m) {
    columns: 1;
  }
}

.list li {
  break-inside: avoid;
  margin-bottom: 1em;
}
</style>
